import { render, staticRenderFns } from "./GroupsLookupSelect.vue?vue&type=template&id=a4d0e8ae&scoped=true&"
import script from "./GroupsLookupSelect.vue?vue&type=script&lang=js&"
export * from "./GroupsLookupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d0e8ae",
  null
  
)

export default component.exports